
import EoNpoPlayer from "../../EoNpoPlayer/EoNpoPlayer.vue"
import EoNpoPlayer2 from "../../EoNpoPlayer2/EoNpoPlayer2.vue"

export default {
  name: "PreprNpoMedia",
  components: {
    EoNpoPlayer,
    EoNpoPlayer2,
  },
  props: {
    /**
     * Prepr data of this element
     */
    data: {
      type: Object,
      default: () => {},
    },
    /**
     * Prop and attribute overwrites
     */
    overwrites: {
      type: Object,
      default: () => {
        return {}
      },
    },
    /**
     * Index
     */
    index: {
      type: Number,
      default: null,
    },
  },
  data () {
    return {
      dataModel: {
        mid: {
          items: [{
            body: null,
            data: {
              key: null,
            },
            description: null,
            id: null,
            image_url: null,
            last_updated: null,
            label: null,
          }],
        },
      },
    }
  },
  computed: {
    normalizedData () {
      return {...this.dataModel, ...this.data}
    },
    posterUrl () {
      return this.normalizedData.mid.items[0].image_url
    },
    atSiteId () {
      return this.$parent?.atSiteId
    },
    atUserId () {
      return this.$parent?.atUserId
    },
    atUserIdDuration () {
      return this.$parent?.atUserIdDuration
    },
  },
}
